import { baseUrl } from '../../network'

export const getProvidersUrl = (companyId: number) => baseUrl + `api/company/${companyId}/providers`
export const getProviderOfferingsUrl = (relationshipId: number) => `${baseUrl}api/relationship/${relationshipId}/offerings` 
export const getPurchaseOrdersUrl = (companyId: number) => baseUrl + `api/company/${companyId}/orders`
export const getPurchaseOrdersFilterUrl = (companyId: number) => baseUrl + `api/company/${companyId}/orders/filters`
